import React from "react";
import { useTranslation } from "react-i18next";
import Icon from "../../../../../common/components/Icon/Icon";

interface AppointmentSummaryProps {
  date: string;
  time: string;
  onEdit: () => void;
}

const AppointmentSummary: React.FC<AppointmentSummaryProps> = ({
  date,
  time,
  onEdit,
}) => {
  const { t } = useTranslation();

  // Guard against empty data
  if (!date || !time) return null;

  // Format the date based on the active language
  const currentLang =
    window.commonVariables?.language.current === "tr" ? "tr-TR" : "en-US";
  const formattedDate = new Date(date).toLocaleDateString(currentLang, {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <div className="appointment-summary">
      <div className="appointment-summary__header">
        <h3 className="appointment-summary__title">
          <Icon iconName="calendar" className="icon--stroke-thick" />
          {t("checkout.appointment.stepTitle", "Randevu Seçimi")}
        </h3>
        <button
          type="button"
          onClick={onEdit}
          className="appointment-summary__edit-btn"
        >
          {t("orderReview.editButton", "Edit")}
        </button>
      </div>

      <div className="appointment-summary__content">
        <p className="appointment-summary__row">
          <strong>{t("orderPage.appointment.date", "Tarih")}:</strong>{" "}
          {formattedDate}
        </p>
        <p className="appointment-summary__row">
          <strong>{t("orderPage.appointment.time", "Saat")}:</strong> {time}
        </p>
      </div>
    </div>
  );
};

export default AppointmentSummary;
